module.exports = __webpack_public_path__ + "static/media/devconnector.5147ffb1.png";